import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import checkBeforeSave from "../../checkBeforeSave/checkBeforeSave";

import {
  Card,
  CardAreaMain,
  CardContent,
  Button,
  CardActions,
  CardActionsSupplemental,
  CircleProgress
} from "reactackle";

import { addAudit } from "../audits/addAudits";
import getInputField from "../customFields/getInputField";
import { isMobile } from "react-device-detect";

class User extends Component {
  state = {
    data: {
      path: this.props.path,
      payload: {
        ...this.props.selectedusers,
        author:
          this.props.userEmail && this.props.userEmail !== undefined
            ? this.props.userEmail
            : ""
      }
    },
    showForm: true
  };

  componentDidMount() {
    //console.log("1212 attendance did mounting");
    if (this.props.operationType === "add") {
      let date = new Date();
      let createDateTime = date.toLocaleString();
      this.stateChangeHandler(createDateTime, "createDateTime", true);
    }
  }

  stateChangeHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  getField = (fieldName, disabled) => {
    return getInputField(
      fieldName,
      this.props.path,
      this.state.data,
      this.stateChangeHandler,
      disabled,
      this.props.ogTableDef,
      this.props.db,
      isMobile
    );
  };

  getFields = () => {
    return Object.keys(this.props.ogTableDef[this.props.path]).map(fldKey => {
      return this.getField(fldKey);
    });
  };

  updateUserTable = () => {
    let cloudPath = "";
    if (
      this.state.data.payload &&
      this.state.data.payload.key &&
      this.state.data.payload.key !== ""
    ) {
      cloudPath = this.props.path + "/" + this.state.data.payload.key;
      Promise.all([
        addAudit(
          this.stateChangeHandler,
          this.props.firebase.auth.currentUser &&
            this.props.firebase.auth.currentUser.phoneNumber
            ? this.props.firebase.auth.currentUser.phoneNumber
            : ""
        )
      ]).then(res => {
        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            return snap.ref.set(this.state.data.payload);
          })
          .catch(err => {
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => this.props.handleEditCancel());
      });
    } else {
      cloudPath = this.props.path;
      Promise.all([
        addAudit(this.stateChangeHandler, this.props.userEmail)
      ]).then(res => {
        var newInv = this.props.firebase.db.ref("/" + cloudPath).push();
        newInv
          .set(this.state.data.payload)
          .catch(err => {
            alert(
              "Please contact support. New user creation failed. Error: " + err
            );
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => this.props.handleEditCancel());
      });
    }
  };

  saveHandler = () => {
    //existing user
    this.updateUserTable();

    //this.props.handleEditCancel();
  };

  getLoader = () => {
    return (
      <CardContent>
        <CircleProgress indeterminate subtitle="Saving..." />
      </CardContent>
    );
  };

  checkInputs = () => {
    if (
      this.state.password !== "" &&
      this.state.data.payload.userEmail !== "" &&
      this.state.data.payload.roleName !== ""
    ) {
      console.log("disabled is false");
      return false;
    } else {
      console.log("disabled is true");
      return true;
    }
  };

  getTopHeader = () => {
    return (
      <div>
        <Card>
          <CardAreaMain>
            {!isMobile && (
              <CardContent>
                <div>
                  <h1>USER</h1>
                </div>
              </CardContent>
            )}
            <CardActions>
              <CardActionsSupplemental>
                {this.props.operationType !== "add" && (
                  <Button
                    text="DELETE"
                    onPress={e => {
                      if (
                        this.state.data.payload.key &&
                        this.state.data.payload.key !== ""
                      ) {
                        window.confirm(
                          "Are you sure you wish to delete this item?"
                        ) &&
                          this.props.handleDelete(
                            this.state.data.payload.key,
                            this.props.path
                          );
                      }
                    }}
                    colorScheme="warning"
                    disabled={!this.state.showForm}
                  />
                )}

                <Button
                  text="SAVE"
                  onPress={() => this.saveHandler()}
                  colorScheme="primary"
                  disabled={
                    !this.state.showForm ||
                    checkBeforeSave(
                      this.props.path,
                      this.state.data.payload,
                      this.props.ogTableDef
                    )
                  }
                />

                <Button
                  text="CANCEL"
                  onPress={() => this.props.handleEditCancel()}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />
              </CardActionsSupplemental>
            </CardActions>
          </CardAreaMain>
        </Card>
      </div>
    );
  };

  render() {
    return (
      <div>
        <div>{this.getTopHeader()}</div>

        {isMobile && (
          <div>
            {this.state.showForm && this.getFields()}
            {!this.state.showForm && this.getLoader()}
          </div>
        )}
        {!isMobile && (
          <Card>
            <CardAreaMain style={{ padding: "0px" }}>
              <CardContent style={{ pading: "0px" }}>
                {this.state.showForm && this.getFields()}
                {!this.state.showForm && this.getLoader()}
              </CardContent>
            </CardAreaMain>
          </Card>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userEmail: state.db.currentUser.userEmail,
    currUser: state.db.currentUser,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    isAdmin: state.ui.isThisAdmin,
    userName: state.db.currentUser.userName,
    attList: state.db.attendance,
    userProfile: state.db.userProfile,
    projects: state.db.projects,
    users: state.db.users,
    editMode: state.ui.editMode,
    selectedusers: state.db.selectedusers,
    operationType: state.ui.operationType,
    showSpinner: state.ui.showSpinner,
    createNewRec: state.ui.operationType === "add",
    db: state.db
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onAddRecord: data => dispatch(actionAddArray2Redux(data)),
    onSelectRecord: params => dispatch(selectARecord(params))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(User);



// WEBPACK FOOTER //
// ./src/app/components/Screens/Users/User.jsx